import { connect } from 'react-redux';

import {
  acceptTermsAndConditions,
  backToIdentifierForm,
  confirmUserSignUp,
  hideMessage,
  resetAuthErrorMessage,
  showAuthLoader,
  submitTemporaryPassword,
  userSignIn,
  verifyUser,
  verifyUserSignUp,
} from '../../actions/Auth';

import SignIn from './SignIn';

const mapStateToProps = ({ auth }) => auth;

const mapDispatchToProps = {
  acceptTermsAndConditions,
  backToIdentifierForm,
  confirmUserSignUp,
  hideMessage,
  resetAuthErrorMessage,
  showAuthLoader,
  submitTemporaryPassword,
  userSignIn,
  verifyUser,
  verifyUserSignUp,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignIn);
